import React from "react";
import { ImageBackground, Platform } from "react-native";
import { Machine } from "stent";
import { connect } from "stent/lib/react";
import config from "config";
import { removeFlowCompletedCookie } from "./utils";
import initializeStateMachine from "./stateMachineConfig";
import renderMap from "./renderMap";

class LoginRegistration extends React.PureComponent {
  constructor(props) {
    super(props);
    const { initialScreenName, initialState } = props;
    initializeStateMachine({ initialScreenName, initialState });
  }

  componentDidMount() {
    if (Platform.OS === "web") removeFlowCompletedCookie()();
  }

  componentWillUnmount() {
    Machine.flush();
  }

  render() {
    return (
      <ImageBackground
        source={{
          uri: `${config.S3_URL}/RocketIntegration/onboarding/loginBg.${
            Platform.OS === "web" ? "svg" : "png"
          }`
        }}
        style={{ width: "100%", height: "100%", backgroundColor: "white" }}
      >
        <ConnectedScreen />
      </ImageBackground>
    );
  }
}

const RenderScreen = ({ goNext, goBack, state }) => {
  const ActualComponent = renderMap({ goNext, goBack, state })[state.name];
  return ActualComponent;
};

const ConnectedScreen = connect(RenderScreen)
  .with("LoginRegistrationStateMachine")
  .map((machine) => ({
    state: machine.state,
    goNext: machine.goNext,
    goBack: machine.goBack
  }));

export default LoginRegistration;
